import { proxy } from "valtio";
import { Routes } from "../routes/baseRoutes";

const K_OTP_RESEND_COUNTDOWN = 60;

export enum SettingsRoutes {
  Account = "Account",
  Collaboration = "Collaboration",
  ShareFeedback = "Share feedback",
  Subscription = "Subscription",
  LogOut = "Log out",
}

export const SettingsRoutesActualRoutesMap = {
  "Account": Routes.settings,
  "Collaboration": Routes.CollaborationsSettings,
  "Share feedback": Routes.ShareFeedbackSettings,
  "Subscription": Routes.SubscriptionSettings,
  "Log out": Routes.SubscriptionSettings,
}

export const SettingsStore = proxy({
  isDeleteDrawerOpen: false,
  isEmailVerDrawerOpen: false,
  isPasswordDrawerOpen: false,
  isUpdatingAccount: false,
  resendOTPCountdown: K_OTP_RESEND_COUNTDOWN,
  resendOTPDisabled: false,
  otpSend: "send" as "send" | "resend",
  // currentRoute: SettingsRoutes.Account,
});

export const disableSettingsOTPResend = () => {
  SettingsStore.resendOTPDisabled = true;
  const interval = setInterval(() => {
    if (SettingsStore.resendOTPCountdown > 0) {
      SettingsStore.resendOTPCountdown -= 1;
    }else {
      SettingsStore.resendOTPDisabled = false;
      SettingsStore.resendOTPCountdown = K_OTP_RESEND_COUNTDOWN;
      clearInterval(interval);
    }
  }, 1000);
};
